const SELECTED_FRAMEWORK_STORAGE_KEY = "selectedFrameworkId";

const readSavedFrameworkId = () => {
  const saved = localStorage.getItem(SELECTED_FRAMEWORK_STORAGE_KEY);
  if (!saved) return null;
  const parsed = parseInt(saved, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

const persistSelectedFrameworkId = (frameworkId) => {
  if (frameworkId == null) {
    localStorage.removeItem(SELECTED_FRAMEWORK_STORAGE_KEY);
    return;
  }
  localStorage.setItem(
    SELECTED_FRAMEWORK_STORAGE_KEY,
    frameworkId.toString()
  );
};

const findActiveFramework = (frameworks, frameworkId) => {
  if (frameworkId == null) return null;
  return (
    (frameworks || []).find(
      (f) => f.is_active && Number(f.framework_id) === Number(frameworkId)
    ) || null
  );
};

const pickDefaultActiveFramework = (frameworks) => {
  const activeFrameworks = (frameworks || []).filter((f) => f.is_active);
  if (activeFrameworks.length === 0) return null;
  return [...activeFrameworks].sort((a, b) =>
    a.framework_name.localeCompare(b.framework_name)
  )[0];
};

export const createFrameworkSlice = (set, get) => ({
  // Do not restore from localStorage until the live framework list is loaded.
  // A cached ID can point at a framework that was removed for this client.
  selectedFrameworkId: null,
  selectedFramework: null,
  frameworks: [],

  // Framework terminology configuration
  frameworkTerminology: {
    criteria: "Criteria",
  },

  // Actions
  setSelectedFramework: (frameworkId) => {
    const { frameworks, updateTerminology } = get();
    const selectedFramework = findActiveFramework(frameworks, frameworkId);
    if (!selectedFramework) return;

    persistSelectedFrameworkId(selectedFramework.framework_id);
    set({
      selectedFrameworkId: selectedFramework.framework_id,
      selectedFramework,
    });

    if (selectedFramework.key) {
      updateTerminology(selectedFramework.key);
    }
  },

  clearSelectedFramework: () => {
    persistSelectedFrameworkId(null);
    set({
      selectedFrameworkId: null,
      selectedFramework: null,
    });
  },

  // Set frameworks data (called from component with Apollo data)
  setFrameworksData: (frameworks) => {
    const list = frameworks || [];
    const { selectedFrameworkId, updateTerminology } = get();

    const candidateId = selectedFrameworkId ?? readSavedFrameworkId();
    const selected =
      findActiveFramework(list, candidateId) ||
      pickDefaultActiveFramework(list);

    if (!selected) {
      persistSelectedFrameworkId(null);
      set({
        frameworks: list,
        selectedFrameworkId: null,
        selectedFramework: null,
      });
      return;
    }

    persistSelectedFrameworkId(selected.framework_id);
    set({
      frameworks: list,
      selectedFrameworkId: selected.framework_id,
      selectedFramework: selected,
    });
    updateTerminology(selected.key);
  },

  // Update terminology based on framework
  updateTerminology: (key) => {
    const terminologyMap = {
      soc2: {
        criteria: "Criteria",
      },
      hipaa: {
        criteria: "Annexure",
      },
      iso_iec_27001_2022: {
        criteria: "Annexure & Clause",
      },
      dpdp_2023: {
        criteria: "Rule & Section",
      },
    };

    const terminology = terminologyMap[key] || terminologyMap["soc2"];
    set({ frameworkTerminology: terminology });
  },
});
